import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

export default function LegalComplianceDefaultWidget({ module }) {
  return (
    <DefaultWidgetTemplate
      module={module}
      route="user_module_legalCompliance_home"
    />
  );
}
